import { render, staticRenderFns } from "./LeadBoardDealActivityTodoList.vue?vue&type=template&id=17c54dde&"
import script from "./LeadBoardDealActivityTodoList.vue?vue&type=script&lang=js&"
export * from "./LeadBoardDealActivityTodoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports